import "../fonts.css"
import { darken, lighten } from '@mui/material';
import createTheme, { Theme } from '@mui/material/styles/createTheme';
import { borderRadius, customBlack, customColor, customColorType, customThemeMode } from '../custom.types';
import * as localeImport from '@mui/material/locale';
const secondaryOpacity = 0.95;
const getCustomColor = (color: customColorType,
  type: "primary" | "secondary" | "error" | "warning" | "info" | "success",
  detail: "main" | "light" | "dark" | "contrastText"): string => {

  let colorStr = "";
  switch (color) {
    case "blue":
      switch (type) {
        case "primary":
          colorStr = customColor.blue;
          break;
        case "secondary":
          colorStr = customColor.secondary;
          break;
        case "error":
          colorStr = customColor.error;
          break;
        case "warning":
          colorStr = customColor.warning;
          break;
        case "info":
          colorStr = customColor.info;
          break;
        case "success":
          colorStr = customColor.success;
          break;
      }
      break;
    case "orange":
      switch (type) {
        case "primary":
          colorStr = customColor.orange;
          break;
        case "secondary":
          colorStr = customColor.secondary;
          break;
        case "error":
          colorStr = customColor.error;
          break;
        case "warning":
          colorStr = customColor.warning;
          break;
        case "info":
          colorStr = customColor.info;
          break;
        case "success":
          colorStr = customColor.success;
          break;
      }
      break;
    case "yellow":
      switch (type) {
        case "primary":
          colorStr = customColor.yellow;
          break;
        case "secondary":
          colorStr = customColor.secondary;
          break;
        case "error":
          colorStr = customColor.error;
          break;
        case "warning":
          colorStr = customColor.warning;
          break;
        case "info":
          colorStr = customColor.info;
          break;
        case "success":
          colorStr = customColor.success;
          break;
      }
      break;
    case "green":
      switch (type) {
        case "primary":
          colorStr = customColor.green;
          break;
        case "secondary":
          colorStr = customColor.secondary;
          break;
        case "error":
          colorStr = customColor.error;
          break;
        case "warning":
          colorStr = customColor.warning;
          break;
        case "info":
          colorStr = customColor.info;
          break;
        case "success":
          colorStr = customColor.success;
          break;
      }
      break;
    case "berry":
      switch (type) {
        case "primary":
          colorStr = customColor.berry;
          break;
        case "secondary":
          colorStr = customColor.secondary;
          break;
        case "error":
          colorStr = customColor.error;
          break;
        case "warning":
          colorStr = customColor.warning;
          break;
        case "info":
          colorStr = customColor.info;
          break;
        case "success":
          colorStr = customColor.success;
          break;
      }
      break;
    case "pink":
      switch (type) {
        case "primary":
          colorStr = customColor.pink;
          break;
        case "secondary":
          colorStr = customColor.secondary;
          break;
        case "error":
          colorStr = customColor.error;
          break;
        case "warning":
          colorStr = customColor.warning;
          break;
        case "info":
          colorStr = customColor.info;
          break;
        case "success":
          colorStr = customColor.success;
          break;
      }
      break;
    case "red":
      switch (type) {
        case "primary":
          colorStr = customColor.red;
          break;
        case "secondary":
          colorStr = customColor.secondary;
          break;
        case "error":
          colorStr = customColor.error;
          break;
        case "warning":
          colorStr = customColor.warning;
          break;
        case "info":
          colorStr = customColor.info;
          break;
        case "success":
          colorStr = customColor.success;
          break;
      }
      break;  
  }

  switch (detail) {
    case "light":
      colorStr = lighten(colorStr, 0.2)
      break;
    case "dark":
      colorStr = darken(colorStr, 0.4)
      break;
    case "contrastText":
      switch (type) {
        default:
          colorStr = "#fff";
          break;
      }
      break;
  }
  return colorStr;
}


export const getCustomTheme = (color: customColorType, mode: customThemeMode, lang: string, formSize: number): Theme => {
  let coreLangObject;
  switch (lang) {
    case "AZ":
      coreLangObject = localeImport.azAZ;
      break;
    case 'US':
      coreLangObject = localeImport.enUS;
      break;
    case "RU":
      coreLangObject = localeImport.ruRU;
      break;
    case 'FR':
      coreLangObject = localeImport.frFR;
      break;
    default:
      coreLangObject = localeImport.trTR;
      break;
  }
  return createTheme({
    palette: {
      mode,
      divider: mode == "light" ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)",
      background: {
        default: mode == "light" ? "rgb(240, 242, 245)" : "rgb(48, 48, 48)",
        paper: mode == "light" ? "rgb(255, 255, 255)" : "rgb(66, 66, 74)",
      },
      primary: {
        main: getCustomColor(color, "primary", "main"),
        light: getCustomColor(color, "primary", "light"),
        dark: getCustomColor(color, "primary", "dark"),
        contrastText: getCustomColor(color, "primary", "contrastText"),
      },
      secondary: {
        main: getCustomColor(color, "secondary", "main"),
        light: getCustomColor(color, "secondary", "light"),
        dark: getCustomColor(color, "secondary", "dark"),
        contrastText: getCustomColor(color, "secondary", "contrastText"),
      },
      error: {
        main: getCustomColor(color, "error", "main"),
        light: getCustomColor(color, "error", "light"),
        dark: getCustomColor(color, "error", "dark"),
        contrastText: getCustomColor(color, "error", "contrastText"),
      },
      warning: {
        main: getCustomColor(color, "warning", "main"),
        light: getCustomColor(color, "warning", "light"),
        dark: getCustomColor(color, "warning", "dark"),
        contrastText: getCustomColor(color, "warning", "contrastText"),
      },
      info: {
        main: getCustomColor(color, "info", "main"),
        light: getCustomColor(color, "info", "light"),
        dark: getCustomColor(color, "info", "dark"),
        contrastText: getCustomColor(color, "info", "contrastText"),
      },
      success: {
        main: getCustomColor(color, "success", "main"),
        light: getCustomColor(color, "success", "light"),
        dark: getCustomColor(color, "success", "dark"),
        contrastText: getCustomColor(color, "success", "contrastText"),
      },
      text: {
        disabled: mode == "light" ? "rgba(0, 0, 0, 0.38)" : "rgba(255, 255, 255, 0.5)",
        primary: mode == "light" ? customBlack : darken("#fff", 0.2),
        secondary: mode == "light" ? "rgba(0, 0, 0, 0.54)" : "rgba(255, 255, 255, 0.7)",
      }
    },
    shape: {
      borderRadius
    },
    typography: {
      fontFamily: [
        "OpenSans-Regular"
      ].join(','),
      fontSize: formSize,
      htmlFontSize: 16,
      allVariants: {
        textTransform: "none",
        color: mode == "light" ? customBlack : "#fff"
      },
      h1: {
        fontFamily: [
          "OpenSans-ExtraBold"
        ].join(','),
        fontSize: formSize * 1.7,
        fontWeight: 600
      },
      h2: {
        fontFamily: [
          "OpenSans-ExtraBold"
        ].join(','),
        fontSize: formSize * 1.6,
        fontWeight: 600
      },
      h3: {
        fontFamily: [
          "OpenSans-Bold"
        ].join(','),
        fontSize: formSize * 1.5,
        fontWeight: 400,
        lineHeight: 1.167,
        letterSpacing: "0rem",
        margin: 0,
        transition: "color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
      },
      h4: {
        fontFamily: [
          "OpenSans-Bold"
        ].join(','),
        fontSize: formSize * 1.37,
        fontWeight: 400,
        lineHeight: 1.167,
        letterSpacing: "0rem",
        margin: 0,
        transition: "color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
      },
      h5: {
        fontFamily: [
          "OpenSans-SemiBold"
        ].join(','),
        fontSize: formSize * 1.2,
        fontWeight: 600
      },
      h6: {
        fontFamily: [
          "OpenSans-SemiBold"
        ].join(','),
        fontSize: formSize,
        fontWeight: 700
      },
      button: {
        fontSize: formSize,
        fontWeight: 0
      },
      caption: {
        fontSize: formSize,
        textTransform: "none"
      },
      subtitle1: {
        fontSize: 15,
        textTransform: "none"
      },
      subtitle2: {
        fontFamily: [
          "OpenSans-Italic"
        ].join(','),
      },
      overline: {
        fontSize: 13,
        textTransform: "none"
      }
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1840
      }
    },
    sidebar: {
      textColor: mode == "light" ? "rgb(52, 71, 103)" : "#fff",
      boxShadow: "2px 2px 10px 0 rgb(0 0 0 / 44%)",
      background: "linear-gradient(180deg, #F6F9FC 0%, #ECECF9 100%)",
      width: 250,
      left: 280,
      marginLeft: "10px",
      marginTop: "10px",
      borderRadius: "0.75rem",
      height: "calc(100vh - 1.5rem)"
    },
    header: {
      height: '58px', // ERKAN => 88px
      background: mode == "light" ? getCustomColor(color, "secondary", "main") : getCustomColor(color, "primary", "main"),
      boxShadow: getCustomColor(color, "primary", "main") + " 0px 30px 60px -12px inset, " + getCustomColor(color, "secondary", "main") + "0px 18px 36px -18px inset",
      marginLeft: 305,
      backgroundColor: "transparent",
      paddingTop: "10px"

    },
    outlet: {
      borderRadius: "8px",
      marginTop: "62px",
    },
    mixins: {
      toolbar: {
        fontSize: formSize
      }
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ".warning-cell": {
            backgroundColor: getCustomColor(color, "warning", "main")
          },
          ".success-cell": {
            backgroundColor: getCustomColor(color, "success", "main")
          },
          ".error-cell": {
            backgroundColor: getCustomColor(color, "error", "main")
          },
          ".primary-cell": {
            backgroundColor: getCustomColor(color, "primary", "main")
          },
          ".info-cell": {
            backgroundColor: getCustomColor(color, "info", "main")
          },
          ".secondary-cell": {
            backgroundColor: getCustomColor(color, "secondary", "main")
          },
          ".kadin-cell": {
            backgroundColor: "lightpink"
          },
          ".erkek-cell": {
            backgroundColor: "lightblue"
          },
          ".purple": {
            backgroundColor: "mediumpurple"
          },
          ".mediumorchid": {
            backgroundColor: "mediumorchid"
          },
          ".beige": {
            backgroundColor: "beige"
          },
          ".lightSalmon": {
            backgroundColor: "lightsalmon"
          },
          ".lavender": {
            backgroundColor: "lavender"
          },
          ".white": {
            backgroundColor: "white"
          },
          ".light-cell": {
            backgroundColor: lighten(getCustomColor(color, "primary", "main"), 0.7)
          },

        }
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            fontSize: formSize,
            '& legend': {
              fontSize: formSize,
            }
          }
        }
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            fontSize: 17,
            fontWeight: 500
          },
          asterisk: {
            color: getCustomColor(color, "error", "main"),
            fontWeight: 500,
            fontSize: 20
          }
        }
      },
      MuiInputLabel: { // Input Label font
        styleOverrides: {
          root: {
            fontSize: formSize,
            height: "auto",
            width: "auto"
          }
        }
      },
      MuiInputBase: { // Input props
        styleOverrides: {
          root: {
            height: formSize * 2.8, // Input  height
            // border: "1px solid purple"
          },
        }
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            fontSize: formSize,
            padding: 0,
            // height: formSize * 2.3, // Inputlar arası mesafeyi düşürmek için eklendi
            // border:"1px solid red"
          }
        }
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: formSize,
            padding: 0,
            height: formSize * 2.7,
          }
        }
      },
      // MuiButtonBase: {
      //   styleOverrides: {
      //     root: {
      //       // fontSize: "10px",
      //       // padding: 0,
      //       height: formSize/4 + "vh",
      //     }
      //   }
      // },
      // MuiIconButton: {
      //   styleOverrides: {
      //     root: {
      //       padding: 0,
      //       height: formSize/4 + "vh",
      //     }
      //   },
      // },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            '& .MuiFormControlLabel-label': {
              fontSize: formSize,
            }
          }
        }
      },
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            fontSize: formSize
          },
          listbox: {
            fontSize: formSize,
            borderRight: "1px solid " + getCustomColor(color, "primary", "main"),
            borderLeft: "1px solid " + getCustomColor(color, "primary", "main"),
            borderBottom: "1px solid " + getCustomColor(color, "primary", "main")
          },
          loading: {
            fontSize: formSize
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: formSize
          }
        }
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontFamily: [
              "OpenSans-Italic"
            ].join(','),
          }
        }
      },
      MuiListItemText: {
        styleOverrides: {
          primary: {
            fontSize: formSize
          }
        }
      }
    }
  },
    coreLangObject
  )
}



// export const customDartTheme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: {
//       main: "#6E98BA",
//       light: "#A6C4E0",
//       dark: "#334F70",
//       contrastText: "#EAF1F7"
//     },
//     secondary: {
//       main: "#f34a51",
//       dark: "#af3439",
//       light: "#ef6e72",
//       contrastText: "#f1ebeb"
//     },
//     error: {
//       main: "#f34a51",
//       dark: "#af3439",
//       light: "#ef6e72",
//       contrastText: "#f1ebeb"
//     },
//     warning: {
//       main: "#ef9004",
//       dark: "#a86501",
//       light: "#F7A835",
//       contrastText: "#141414"
//     },
//     info: {
//       main: "#21b4f3",
//       dark: "#197eaa",
//       light: "#4ec5f7",
//       contrastText: "#141414"
//     },
//     success: {
//       main: "#55c55a",
//       dark: "#357b37",
//       light: "#75ce79",
//       contrastText: "#141414"
//     },
//   }
// })